/**
 * @module doesActionEndpointExistInStore
 */

import actionEndpointStore from '../store/actionEndpointStore';
import { ActionEndpointCacheState } from '../store/schema/actionEndpointCache';

/**
 * @function
 * Checks whether the action endpoint is present in the satchel store
 * @returns {boolean} whether the action endpoint is present in the store
 */
const doesActionEndpointExistInStore = (): boolean => {
    return actionEndpointStore.cache.state !== ActionEndpointCacheState.Empty;
};

export default doesActionEndpointExistInStore;
